module.exports = __webpack_public_path__ + "static/the-handmaids-tale-7e3dce7dddce8b2039cf5ff102709ef1.jpg";